import React, { useEffect } from "react";
import { Form, Input, Button, Progress, Row, Col } from "antd";
import "./Phone.css";
import { fixNumbers } from "utils";

export const LoginPhoneForm = ({ submitting, onFinish, failed, timer }) => {
	const [form] = Form.useForm();
	useEffect(() => {
		if (failed) {
			form.resetFields();
		}
	}, [failed]);
	return (
		<Form onFinish={onFinish} form={form}>
			<Form.Item
				label="شماره همراه"
				name="phone"
				rules={[
					{ required: true, message: "ورود شماره موبایل الزامی است" },
					{
						pattern: /^09[0-9]{9}$/,
						transform: fixNumbers,
						message: "لطفا یک شماره موبایل صحیح وارد نمایید.",
					},
				]}
				className="no-red-star mb-36"
			>
				<Input className="login-input f-22 input-number" disabled={submitting} />
			</Form.Item>
			<Form.Item>
				<Row gutter={[8, 8]} align="middle">
					<Col span={timer ? 20 : 24}>
						<Button
							type="primary"
							htmlType="submit"
							block={true}
							disabled={submitting || timer}
							loading={submitting}
							style={{ borderRadius: "5px" }}
							size="large"
						>
							{timer ? "تا ارسال دوباره کد" : "ارسال کد ورود"}
						</Button>
					</Col>
					{!!timer && (
						<Col span={4}>
							<Progress
								type="circle"
								status="active"
								width={50}
								format={(value) => `${value} ثانیه`}
								percent={timer}
							/>
						</Col>
					)}
				</Row>
				{failed && (
					<p className="text-warning" style={{ paddingTop: "6px" }}>
						خطا : لطفا دوباره شماره همراه را وارد نمایید
					</p>
				)}
			</Form.Item>
		</Form>
	);
};
